const originalBooking = {
  duration: 30,
  price: 100,
  date: "2025-07-10",
  time: "14:00",
  clinic: {
    lat: 40.712776,
    lng: -74.005974,
    name: "Downtown Health Center",
    id: "clinic_001",
    address: "123 Main St, New York, NY 10001"
  }
};

const newBooking = {
  duration: 45,
  price: 120,
  date: "2025-07-12",
  time: "10:30",
  clinic: {
    lat: 34.052235,
    lng: -118.243683,
    name: "Westside Medical Clinic",
    id: "clinic_002",
    address: "456 Sunset Blvd, Los Angeles, CA 90028"
  }
};

module.exports = {
  originalBooking,
  newBooking
};
